import { Injectable, AfterViewInit, OnDestroy } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { AdSearchService } from '../services/adsearch.service';
import { Subscription } from 'rxjs';

declare var PhotoSwipe: any;
declare var PhotoSwipeUI_Default: any;

@Injectable({
    providedIn: 'any'
})

export abstract class Gallery implements AfterViewInit, OnDestroy {

    info:any = {};
    viewInstance : any = {};

    galleryOpened:any = false;

    actionSubscription: Subscription;

    protected backbuttonSuperSubscription: Subscription;


    constructor(
        protected srs: AdSearchService,
        protected gs: GeneralService
    ) {

    }

    setData(info, viewInstance){
        this.info = info;
        this.viewInstance = viewInstance;
    }

    ngAfterViewInit(){

        if(this.actionSubscription)
          this.actionSubscription?.unsubscribe();
    
        this.actionSubscription = this.gs.actions$.subscribe(result => {
          if(result?.adId == this.info?.adId && this.viewInstance?.typeComponent)
            switch(result?.action){
              case 'lightGallery':
                this.setGallery(result.item, result.galleryList || 'imagesAndVideos');
            }
        });

    }

    ngOnDestroy() {
        this.actionSubscription?.unsubscribe();
        this.backbuttonSuperSubscription?.unsubscribe();
        this.gs.setAction({});
    }

    setGallery(dataItem, galleryList = 'imagesAndVideos') {

        var images = [];
        let index: any = 0;
        
        if(typeof this.info[galleryList] !=='undefined')
        Object.entries(this.info[galleryList]).forEach(([key, value]: any) => {
            if (!value['tags']?.filter(tag => tag?.attr?.type == 'highlight' || [32].indexOf(parseInt(tag.tag_id)) > -1)?.length || typeof value.tags == 'undefined') {

                if ((value?.fileId && value?.fileId == dataItem?.fileId) || (value?.id && value?.id == dataItem?.id))
                    index = parseInt(key);
                               
                if (dataItem?.type == 'iframe') {
                    images.push({
                        content: '<iframe src="' + (value?.link || value?.url) + '" width="100%" style="height:calc(100vh - 88px); margin-top:44px;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>',
                        //title: value?.subHtml || value?.title || ''
                    });
                } else if (value?.url)
                    images.push({
                        content: '<iframe src="' + value.url + '/?autoplay=1" width="100%" height="100%" frameborder="0" class="video" allow="autoplay; fullscreen" allowfullscreen></iframe>',
                        //title: value?.subHtml || value?.title || ''
                    });
                else
                    images.push(
                        {
                            src: value['src'],
                            w: value['src_width'],
                            h: value['src_height'],
                            title: value?.subHtml || value?.title || ''
                        }
                    );
            }
        });

        var pswpElement = document.querySelectorAll('.pswp')[0];
        // Initializes and opens PhotoSwipe

        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, images, {
            index: index, // start at first slide
            preloaderEl: false,
            placeholder:true
        });

        gallery.listen('afterChange', ()=>{
            let items = gallery.items;
            if (!!items?.length ) {
                let cur = gallery.getCurrentIndex();

                Object.entries(items).forEach(([item,v]) => {
                    if(item != cur && items[item]?.content && items[item] && typeof items[item].container !== 'undefined' && items[item]?.container)
                        items[item].container.innerHTML = '';
                });
                
                if (items[cur]?.content && typeof items[cur].container !== 'undefined')
                    items[cur].container.innerHTML = items[cur]?.content;

                if (items[cur]?.content?.indexOf('video') > -1)
                    pswpElement.classList.add('tiny');
                else
                    pswpElement.classList.remove('tiny');
            } else {
                pswpElement.classList.remove('tiny');
            }
        });

        gallery.listen('close', () => {

            this.galleryOpened = false;
            if(this.viewInstance?.lightGalleryOpened)
                this.viewInstance.lightGalleryOpened = false;

            pswpElement.querySelectorAll('iframe').forEach(i => {
                i.remove();
            });
        });

        gallery.init();

        this.galleryOpened = gallery;
    }
}